import type { SVGProps } from "react";

export function IconBlackPackage(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.75 6.25H57.75V57.75H6.25V6.25H26.25V18.75H37.75V6.25ZM36.25 6.25H27.75V17.25H36.25V6.25ZM37.25 33.25H50.75V46.75H49.25V35.8107L41.4752 43.5855C38.1684 46.8923 33.6834 48.75 29.0069 48.75H28C19.8538 48.75 13.25 42.1462 13.25 34H14.75C14.75 41.3178 20.6822 47.25 28 47.25H29.0069C33.2856 47.25 37.389 45.5503 40.4145 42.5248L48.1893 34.75H37.25V33.25Z"
        fill="#23232C"
      />
    </svg>
  );
}
